/**
 * Favorite Locations List Component
 */

import React from 'react';
import { useTranslation } from 'react-i18next';
import FavoriteLocationCard from './FavoriteLocationCard';
import './FavoriteLocationsList.css';

const FavoriteLocationsList = ({ locations, onEdit, onDelete }) => {
  const { t } = useTranslation('common');
  
  if (!locations || locations.length === 0) {
    return (
      <div className="no-locations">
        <p>📍 {t('settings.no_favorite_locations') || 'No favorite locations yet'}</p>
        <p className="help-text">{t('settings.favorite_locations_help')}</p>
      </div>
    );
  }

  return (
    <div className="favorite-locations-list">
      {locations.map(location => (
        <FavoriteLocationCard
          key={location.id}
          location={location}
          onEdit={onEdit}
          onDelete={onDelete}
        />
      ))}
    </div>
  );
};

export default FavoriteLocationsList;
